import { TradeSide } from ".";

export type C2COrderParams = {
  fiat: string;
  amount: string;
  asset: string;
};

export type C2CHfoxOrderParams = {
  fiat: string;
  amount: string;
  wallet_id: string;
  offer_id?: string;
};

export type C2COrder = {
  id: number;
  offer_id: string;
  trace_id: string;
  otc_order_id: string;
  quote_asset_id: string;
  base_asset_id: string;
  avg_price: string;
  quote: Asset;
  base: Asset;
  fiat: Fiat;
  fiat_price: string;
  amount: string;
  fiat_amount: string;
  filled_amount: string;
  obtained_amount: string;
  extra_obtained_amount: string;
  atm_fee: string;
  side: TradeSide;
  payway: string;
  payway_id: number;
  status: C2COrderStatus;
  created_at: string;
  updated_at: string;
  maker: OTCMaker;
  usdt_fiat_price: string;
  comment: string;
  payways: Payways;
  type: C2COrderType;
};

type Asset = {
  asset_id: string;
  symbol: string;
  name: string;
  icon: string;
};

export enum C2COrderType {
  HFOX = "hfox",
  ATM = "atm"
}

export type Payways = {
  alipay?: AliPay;
  wxpay?: WXPay;
  unipay?: UniPay;
};

export type AliPay = {
  account: string;
  image: string;
  image_url: string;
  name: string;
  phone: string;
  remark: string;
};

export type WXPay = {
  account: string;
  image: string;
  image_url: string;
  name: string;
  phone: string;
  remark: string;
};

export type UniPay = {
  bank_name: string;
  branch: string;
  card_no: string;
  name: string;
  phone: string;
  remark: string;
};

export type C2COffer = {
  fiat_symbol: string;
  asset_symbol: string;
  asset_id: string;
  price: string;
  min_asset: string;
  max_asset: string;
  min_fiat: string;
  max_fiat: string;
};

export type OTCMaker = {
  user_id: string;
  maker_id: string;
  maker_name: string;
  description: string;
  paymentable: boolean;
  payways: any;
  payway_binding: any;
  order_count: number;
  cancel_count: number;
  complete_rate: string;
  wallet_id: string;
  created_at: string;
  status: string;
};

export type Fiat = "cny" | "usd";

export enum C2COrderStatus {
  OTCPending = "otc_pending",
  OTCPaid = "otc_paid",
  OTCUnpaidCancelled = "otc_unpaid_cancelled",
  OTCPaidCancelled = "otc_paid_cancelled",
  OTCPaidConfirmed = "otc_paid_confirmed",
  OTCDone = "otc_done",
  ATMPending = "atm_pending",
  ATMTrading = "atm_trading",
  ATMFilled = "atm_filled",
  ATMCancelled = "atm_cancelled",
  ATMRejected = "atm_rejected",
  ATMTimeout = "atm_timeout"
}
